import "react-image-gallery/styles/css/image-gallery.css";
import ImageGallery from "react-image-gallery";
import React from 'react'
import { Container } from 'react-bootstrap';
import './navbar/navbar.css';

export default function Gallery(){
    const images = [
        {
            original: 'https://i.postimg.cc/DzQQ31wh/Image-1.png',
            thumbnail: 'https://i.postimg.cc/fRn0WkFR/Image-2.png',
        },
        {
            original: 'https://i.postimg.cc/kMxtw8Mt/2nd-Plan-de-travail-1-1-min.jpg',
            thumbnail: 'https://i.postimg.cc/VNKB4tY8/2nd-Plan-de-travail-1-min.png',
        },
        {
            original: 'https://i.postimg.cc/05LcK7WM/DSC4038-min-min.png/',
            thumbnail: 'https://i.postimg.cc/QxqBp3NL/DSC4038-min.png',
        },
        {
            original: 'https://i.postimg.cc/y6Xk0Hnm/DSC4156-1-min.jpg',
            thumbnail: 'https://i.postimg.cc/JzgnR44L/DSC4156-min.png',
        },
    ];
    return (
        <section id="Gallery">
            <Container className="gallery-container">
                <h1>Last Edition's Pictures</h1>
                <ImageGallery items={images} />
            </Container>
        </section>)
}
